import { serviceGet } from '@/shared/lib/core/request';

export const API_OPERATIONS_URL = '/v2/api/operations';
export const serviceGetOperations = serviceGet.bind(null, API_OPERATIONS_URL);
